import { GridCellParams } from '@mui/x-data-grid-pro';
import { IPlacementMarginDetailsResponseScenarioSplitItem } from 'store/redux-store/margin-tool/slices/placement/placement-add-edit-scenario/add-edit-placement-scenario.model';

export type CustomGridCellParams = {
  editCell: GridCellParams;
  error: string;
};

export interface ITimeOffProps {
  splitIndex: number;
  field: IPlacementMarginDetailsResponseScenarioSplitItem;
}

export const dateTimeFormat = 'YYYY-MM-DDTHH:mm:ss';
export const dateTimeLabelFormat = 'MM/DD/YYYY';
